import React from 'react';
import Auth from 'services/Auth';
import {
  Redirect,
} from "react-router-dom";
import Logo from 'assets/logo.png';

class Login extends React.Component {
  state = {
    redirectToReferrer: false,
    errors: '',
    inputEmail: '',
    inputPassword: '',
  };

  mounted = false;

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleChange = (event) => {
    const target = event.target;
    const field = target.id;
    if (!field) return;
    this.setState({
      [field]: target.value,
    });
  };

  login = (event) => {
    event.preventDefault();
    Auth.authenticate(this.state.inputEmail, this.state.inputPassword).then(() => {
      if (this.mounted) this.setState({ redirectToReferrer: true });
    }).catch((errors) => {
      if (this.mounted) this.setState({ errors });
    });
  };

  render() {
    let { from } = (this.props.location && this.props.location.state) || { from: { pathname: "/" } };
    let redirectToReferrer = Auth.isAuthenticated && this.props.withRedirect;
    let canSubmit = this.state.inputEmail > '' && this.state.inputPassword > '';

    const renderErrors = () => {
      return this.state.errors.length ? (
       <div className="alert alert-danger" role="alert">{this.state.errors.join(' ')}</div>
      ) : null;
    };

    if (redirectToReferrer) return <Redirect to={from} />;

    return (
      <div className="signin">
        <form className="form-signin">
          <div className="mb-4">
            <img src={Logo} width="72" height="72" alt="Logo" />
          </div>
          <h1 className="h3 mb-3 font-weight-normal">Представьтесь пожалуйста</h1>

          {renderErrors()}
          <label htmlFor="inputEmail" className="sr-only mb-4">E-mail адрес</label>
          <input type="email"
            id="inputEmail" className="form-control mb-4" placeholder="Email address" required autoFocus
            value={this.state.inputEmail} onChange={this.handleChange} />
          <label htmlFor="inputPassword" className="mb-4 sr-only">Пароль</label>
          <input type="password" id="inputPassword" className="form-control mb-4"
            placeholder="Password" required value={this.state.inputPassword} onChange={this.handleChange} />
          <button className="btn btn-lg btn-primary btn-block" type="submit"
            onClick={this.login} disabled={!canSubmit}>Войти</button>
          <p className="mt-5 mb-3 text-muted">&copy; 2019</p>
        </form>
      </div>
    );
  }
}

export default Login;